import { render, staticRenderFns } from "./Register-company-education.vue?vue&type=template&id=4eb550fc&scoped=true&"
import script from "./Register-company-education.vue?vue&type=script&lang=js&"
export * from "./Register-company-education.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb550fc",
  null
  
)

export default component.exports